var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCrossImage = function SvgCrossImage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 10"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#cross-image_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.948 9.937a.95.95 0 0 1-.673-.228.947.947 0 0 1 0-1.335L8.317.332A.947.947 0 0 1 9.7 1.62L1.611 9.71a.95.95 0 0 1-.663.227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98 9.937a.95.95 0 0 1-.662-.275L.276 1.62A.947.947 0 0 1 1.61.285l8.09 8.041a.947.947 0 0 1 0 1.383.95.95 0 0 1-.72.228"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cross-image_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h10v10H0z"
  })))));
};
export default SvgCrossImage;